import React from 'react';
import { Link } from 'react-router-dom';

const API_URL = '';

export default function CGVPage() {
  return (
    <div className="min-h-screen bg-[#FCFBF9]">
      <div className="max-w-3xl mx-auto px-4 py-16">
        <h1 className="text-3xl font-serif font-bold mb-8" data-testid="cgv-title">Conditions Generales de Vente</h1>
        <p className="text-sm text-[#6B6A68] mb-8">Derniere mise a jour : Avril 2026</p>

        <div className="space-y-8 text-sm text-[#3A3938] leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold mb-3">1. Objet</h2>
            <p>Les presentes Conditions Generales de Vente (CGV) regissent les ventes de produits effectuees sur le site bloom-lingerie.com, exploite par Bloom Lingerie. Toute commande implique l'acceptation sans reserve des presentes CGV.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">2. Produits</h2>
            <p>Les produits proposes sont decrits avec la plus grande exactitude possible. Les photographies n'ont pas de valeur contractuelle. Bloom Lingerie ne peut etre tenue responsable des variations mineures de couleur dues aux ecrans.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">3. Prix</h2>
            <p>Les prix sont indiques en Dinars Algeriens (DA) toutes taxes comprises. Bloom Lingerie se reserve le droit de modifier ses prix a tout moment, etant entendu que le prix applique sera celui en vigueur au moment de la validation de la commande.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">4. Commande</h2>
            <p>La commande est confirmee apres validation des informations de livraison et du mode de paiement. Un email de confirmation est envoye a l'adresse email fournie. Le paiement s'effectue exclusivement a la livraison (Cash on Delivery — COD).</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">5. Livraison</h2>
            <p>La livraison est assuree par World Express sur l'ensemble des 58 wilayas d'Algerie. Les delais de livraison sont indicatifs (generalement 2 a 5 jours ouvrables). Les frais de livraison sont calcules en fonction de la wilaya de destination et du type de livraison choisi (domicile ou bureau).</p>
            <p className="mt-2">La livraison est gratuite pour toute commande superieure a 10 000 DA.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">6. Paiement</h2>
            <p>Le paiement s'effectue uniquement en especes a la reception du colis (Cash on Delivery). Aucun paiement en ligne n'est requis. Le montant exact de la commande doit etre regle au livreur.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">7. Retour et echange</h2>
            <p>Vous disposez d'un delai de 48 heures apres reception pour signaler tout defaut ou non-conformite du produit. Les articles doivent etre retournes dans leur emballage d'origine, non portes et avec les etiquettes intactes. Les articles en promotion ou soldes ne sont ni repris ni echanges.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">8. Donnees personnelles</h2>
            <p>Les informations collectees lors de la commande sont necessaires au traitement de celle-ci. Elles sont traitees conformement a notre <Link to="/privacy" className="text-[#D4AF37] underline">Politique de Confidentialite</Link>.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">9. Responsabilite</h2>
            <p>Bloom Lingerie ne saurait etre tenue responsable des dommages resultant d'une mauvaise utilisation des produits achetes. Notre responsabilite est limitee au montant de la commande.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">10. Contact</h2>
            <p>Pour toute question relative aux presentes CGV, contactez-nous a : <a href="mailto:bloom.lingerie.store@gmail.com" className="text-[#D4AF37] underline">bloom.lingerie.store@gmail.com</a></p>
          </section>
        </div>
      </div>
    </div>
  );
}
